var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.cliente && !_vm.expediente)?_c('header-component',{attrs:{"noAction":""}}):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ag-datatable',{attrs:{"title":"Listado","headers":_vm.headers,"items":_vm.items,"emitClickRow":""},on:{"click-row":_vm.clickRow}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }